import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA} from "@angular/material/dialog";

@Component({
  selector: 'app-view-follow-up-education',
  templateUrl: './view-follow-up-education.component.html',
  styleUrls: ['./view-follow-up-education.component.scss']
})
export class ViewFollowUpEducationComponent implements OnInit {
  assessmentData: any;
  constructor(
      @Inject(MAT_DIALOG_DATA) public data: any) {

  }

  ngOnInit(): void {
    this.assessmentData = this.data; // A
    console.log('ASSESSMENTS ANSWER',this.assessmentData)

  }

}
